export const KLEVU_CUSTOM_FILTER_NAMES: Record<string, string> = {
  klevu_price: "Price",
};
